import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-grid',
  templateUrl: './licence-grid.component.html',
  styleUrls: ['./licence-grid.component.css']
})
export class LicenceGridComponent implements OnInit {
  title="Licences";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/licence/licence-grid/licence-grid.component.ts